export interface EffectiveValueContext
{
    blueprint: any;
    currentData: any;
    executeExpression: (expression: string, index?: number) => any;
    index?: number;
}

const resolveLogitoChoice = (ctx: EffectiveValueContext): any =>
{
    const { blueprint, executeExpression, index } = ctx;

    if (blueprint.defaultValue)
    {
        const executedValue = executeExpression(blueprint.defaultValue, index);

        return blueprint.options
            ?.filter((opt: any) => opt.value === String(executedValue))
            .map((opt: any) => opt.key) ?? [];
    }

    return blueprint.options
        ?.filter((opt: any) => opt.selected)
        .map((opt: any) => opt.key) ?? [];
};

const resolveNumeric = (ctx: EffectiveValueContext): number =>
{
    const { blueprint, executeExpression, index } = ctx;

    if (!blueprint.defaultValue)
        return null;

    const executedValue = executeExpression(blueprint.defaultValue, index);

    if (executedValue === null || executedValue === undefined)
        return null;

    const n = Number(executedValue);

    if (Number.isNaN(n))
        return null;

    const precision = blueprint.fieldType === 'Integer' ? 0 : blueprint.precision;

    return parseFloat(n.toFixed(precision));
};

const resolveText = (ctx: EffectiveValueContext): string =>
{
    const { blueprint, executeExpression, index } = ctx;

    if (!blueprint.defaultValue)
        return '';

    const executedValue = executeExpression(blueprint.defaultValue, index);

    return executedValue ?? '';
};

export const resolveEffectiveEntryData = (ctx: EffectiveValueContext): any =>
{
    const { blueprint, currentData, executeExpression, index } = ctx;

    if (!blueprint || !('type' in blueprint))
        return currentData;

    // Globalna zasada: domyślną wartość podstawiamy tylko gdy bazowa wartość to null.
    // Dzięki temu np. [] po ręcznym wyczyszczeniu NIE wraca do defaultValue.
    if (currentData !== null)
        return currentData;

    switch (blueprint.type)
    {
        case 'logito-choice':
            return resolveLogitoChoice(ctx);

        case 'numeric':
            return resolveNumeric(ctx);

        case 'boolean':
            return blueprint.defaultValue;

        case 'text':
            return resolveText(ctx);

        default:
            if (typeof blueprint.defaultValue === 'string' && blueprint.defaultValue)
                return executeExpression(blueprint.defaultValue, index);

            if ('defaultValue' in blueprint)
                return blueprint.defaultValue;

            return currentData;
    }
};

